module.exports = __webpack_public_path__ + "img/Simeji-wh-app.baa2fc5f.svg";